import { FC } from "react";

interface Step3Props {
  companyName: string;
  invitationCode: string;
}

const Step3: FC<Step3Props> = ({ companyName, invitationCode }) => {
  const isJoiningViaCode = invitationCode.trim().length > 0;

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-lg font-semibold text-gray-900 mb-4">
          {isJoiningViaCode ? "Review & Confirm" : "Company Setup"}
        </h3>
        <p className="text-sm text-gray-600 mb-6">
          {isJoiningViaCode 
            ? "Please review the details before completing your setup."
            : "Review your company setup before proceeding."}
        </p>
      </div>

      {isJoiningViaCode ? (
        // Joining via invitation code
        <div className="space-y-4">
          <div className="border-2 border-green-500 bg-green-50 rounded-lg p-6">
            <div className="flex items-start">
              <div className="flex-shrink-0 w-10 h-10 bg-green-100 rounded-full flex items-center justify-center mr-4">
                <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <div className="flex-1">
                <h4 className="text-base font-semibold text-gray-900 mb-2">
                  Joining with Invitation Code
                </h4>
                <p className="text-sm text-gray-600 mb-3">
                  You will join an existing company and get immediate access to their projects.
                </p>
                <div className="bg-white border border-gray-200 rounded-md p-3">
                  <p className="text-sm text-gray-700">
                    <span className="font-medium">Invitation Code:</span>{" "}
                    <span className="text-green-600 font-mono">{invitationCode}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-md p-4">
            <p className="text-sm text-blue-800">
              <strong>Note:</strong> You will be granted access to the games specified by your team. No demo content will be created.
            </p>
          </div>
        </div>
      ) : (
        // Creating new company
        <div className="space-y-4">
          <div className="border-2 border-purple-500 bg-purple-50 rounded-lg p-6">
            <div className="flex items-start">
              <input
                type="radio"
                name="companyOption"
                checked
                readOnly
                className="mt-1 mr-3 text-purple-600 focus:ring-purple-500"
              />
              <div className="flex-1">
                <h4 className="text-base font-semibold text-gray-900 mb-2">
                  Create New Company
                </h4>
                <p className="text-sm text-gray-600 mb-3">
                  Start fresh with your own company workspace.
                </p>
                <div className="bg-white border border-gray-200 rounded-md p-3">
                  <p className="text-sm text-gray-700">
                    <span className="font-medium">Company Name:</span>{" "}
                    <span className="text-purple-600">{companyName || "Not specified"}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-md p-4">
            <p className="text-sm text-blue-800">
              <strong>Note:</strong> A template game will be created in your workspace to help you get started quickly.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default Step3;

